import moment from 'moment';
import pointIcon from '../../assets/images/sc2021/Points.svg';
import stepsIcon from '../../assets/images/sc2021/Steps.svg';
import challenge from '../../assets/images/sc2021/challengesc.svg';
import googlefit from '../../assets/images/connectedApps/GoogleFit.png';
import healthConnectLogo from '../../assets/images/connectedApps/healthConnect.png';
import mapMyWalkLogo from '../../assets/images/connectedApps/mayMyWalk.png';
import mapMyFitnessLogo from '../../assets/images/connectedApps/mapMyFitness.png';
import underArmourLogo from '../../assets/images/connectedApps/underarmour.png';
import appleHealth from '../../assets/images/connectedApps/applehealth.jpeg';
import garmin from '../../assets/images/connectedApps/garmin.jpeg';
import stava from '../../assets/images/connectedApps/stava.jpeg';
import wahoo from '../../assets/images/connectedApps/wahoo.jpeg';
import fitbit from '../../assets/images/connectedApps/fitbit.jpeg';
import mapmyrun from '../../assets/images/connectedApps/mapmyrun.jpeg';
import mapmyride from '../../assets/images/connectedApps/mapmyride.jpeg';
import polar from '../../assets/images/connectedApps/polar.jpeg';
import hdorIcon from '../../assets/images/connectedApps/HDOR-Logo-50px.png';
import { FaRunning } from 'react-icons/fa';
import { BiCycling } from 'react-icons/bi';
import { IoFootstepsSharp } from 'react-icons/io5';
import { FaWalking } from 'react-icons/fa';
import {
  FITBIT_SOCIAL_LINKS,
  GARMIN_SOCIAL_LINKS,
  GOOGLE_FIT_SOCIAL_LINKS,
  INDIVIDUAL_ACTIVITY,
  INDIVIDUAL_SUMMARY,
  INDIVIDUAL_SUMMARY_V2,
  MAPMYRIDE_SOCIAL_LINKS,
  MAPMYRUN_SOCIAL_LINKS,
  POLAR_SOCIAL_LINKS,
  SOCIAL_LINK_PLATFORM,
  STAVA_SOCIAL_LINKS,
  SUPPORTED_SPORTS_FITBIT,
  SUPPORTED_SPORTS_GARMIN,
  SUPPORTED_SPORTS_GOOGLEFIT,
  SUPPORTED_SPORTS_MAPMYRIDE,
  SUPPORTED_SPORTS_MAPMYRUN,
  SUPPORTED_SPORTS_POLAR,
  SUPPORTED_SPORTS_STAVA,
  SUPPORTED_SPORTS_WAHOO,
  TEAM_ACTIVITY,
  TEAM_ACTIVITY_DISTANCE,
  TEAM_SUMMARY,
  TEAM_SUMMARY_POINTS,
  WAHOO_SOCIAL_LINKS,
} from '../Constants';

import * as apiPath from '../../services/apiPath';
import dayjs from 'dayjs';

export const Date1Pipe = (value) => {
  if (value) {
    var monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    let dateArr = value.split('-');
    let day = dateArr[0];
    let month = parseInt(dateArr[1]) - 1;
    let year = dateArr[2];
    let dateStr = day + ' ' + monthNames[month] + ', ' + year;
    return dateStr;
  }
  return null;
};

export const currency = (value) => {
  if (value) {
    if (value === 'INR') {
      return 'Rs.';
    }
    if (value === 'USD') {
      return '$';
    }
    if (value === 'GBP') {
      return '£';
    }
    if (value === 'EUR') {
      return '€';
    }
  }
  return '-';
};

export const DateFormatter = (date) => {
  if (date) {
    var monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    let val = new Date(date);
    return val.getDate() + ' ' + monthNames[val.getMonth()] + ' ' + val.getFullYear();
  }
  return '-';
};

export const HdorDate = (value) => {
  if (value) {
    var monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    let dateArr = value.split('-');
    let day = dateArr[0];
    let month = parseInt(dateArr[1]) - 1;
    let year = dateArr[2];
    let dateStr = monthNames[month] + ' ' + day + ', ' + year;
    return dateStr;
  } else {
    return null;
  }
};

export const DateForUserLog = (value) => {
  if (value) {
    let dateArr = value.split(' ');
    let day = dateArr[0];
    let month = dateArr[1];
    let dateStr = month + ' ' + day;
    return dateStr;
  }
  return;
};

export const OneViewRunDate = (value) => {
  if (value) {
    let dateArr = value.split(' ');
    let day = dateArr[0];
    let month = dateArr[1];
    let year = dateArr[2];
    let dateStr = month + ' ' + day + ', ' + year;
    return dateStr;
  }
  return;
};

export const OneViewRideDate = (value) => {
  if (value) {
    let dateArr = value.split(' ');
    let day = dateArr[0];
    let month = dateArr[1];
    let year = dateArr[2];
    let dateStr = month + ' ' + day + ', ' + year;
    return dateStr;
  }
  return;
};

export const DateFromStringMonthPipe = (value) => {
  if (value) {
    let dateArr = value.split('-');
    let day = dateArr[0];
    let month = dateArr[1];
    let year = dateArr[2];
    let dateStr = day + ' ' + month + ', ' + year;
    return dateStr;
  }
  return;
};

export const StepCountRound = (value) => {
  if (value) {
    var length = (value + '').length,
      index = Math.ceil((length - 3) / 3),
      suffix = ['K', 'M', 'B', 'T'];

    if (length < 4) return value;

    return (value / Math.pow(1000, index)).toFixed(1).replace(/\.0$/, '') + suffix[index - 1];
  }
  return;
};

export const DistancePipe = (value) => {
  if (value) {
    const toFixed = (n, fixed) => +`${n}`.match(new RegExp(`^-?\\d+(?:.\\d{0,${fixed}})?`))[0];
    let newNum = toFixed(value, 2);
    return newNum;
  }
  return;
};

export const CountryFilter = (value) => {
  if (value) {
    let returnValue = null;
    if (value === 'country') {
      returnValue = "Top Country's";
    } else if (value === 'bu') {
      returnValue = "Top BU's";
    } else {
      returnValue = value;
    }
    return returnValue;
  }
  return;
};

export const GroupFilter = (value) => {
  if (value) {
    let returnValue = null;
    if (value === 1) {
      returnValue = 'EBU';
    } else if (value === 2) {
      returnValue = 'Digital';
    }
    return returnValue;
  }
  return;
};

export const FreedomRunDistancePipe = (value) => {
  if (value) {
    let innumber = value * 1000;
    let removeFrac = Math.round(innumber);
    let newnum = removeFrac / 1000;
    return newnum;
  }
  return;
};

export const RoundDistancePipe = (value) => {
  if (value) {
    let innumber = value;
    let removeFrac = Math.round(innumber);
    let newnum = removeFrac;
    return newnum;
  }
  return;
};

export const GenderPipe = (value) => {
  if (value) {
    if (value === 'M' || value === 'Male') return 'Male';
    else if (value === 'F' || value === 'Female') return 'Female';
    else if (value === 'O' || value === 'Other') return 'Other';
    else return null;
  }
  return;
};

export const GenderDashboardPipe = (value) => {
  if (value) {
    if (value === 'M') return 'Male';
    else if (value === 'F') return 'Female';
    else if (value === 'O') return 'Other';
    else if (value === 'P') return 'Male';
    else return null;
  }
  return;
};

export const PaceWithoutUnitPipe = (value) => {
  if (value) {
    let str = value.split(':');
    return parseInt(str[0]) + ':' + str[1];
  }
  return;
};

export const TimeFormatFromSecPipe = (prevalue) => {
  if (prevalue) {
    let value = parseInt(prevalue);
    let hours;
    let mins;
    let seconds;
    if (value > 0) {
      hours = Math.trunc(value / 3600);
      mins = Math.trunc((value - hours * 3600) / 60);
      seconds = Math.trunc(value - hours * 3600 - mins * 60);
      if (hours < 10) {
        hours = '0' + hours;
      }
      if (mins < 10) {
        mins = '0' + mins;
      }
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      return '' + hours + ':' + mins + ':' + seconds;
    } else {
      return '00:00:00';
    }
  }
  return;
};

export const TimeWithoutSecPipe = (value) => {
  if (value) {
    let str = value.split(':');
    return parseInt(str[0]) + ':' + str[1];
  } else {
    return value;
  }
};

export const ActivityPipe = (value) => {
  if (value) return value.split(',');
  return null;
};

export const SearchPipe = (value, searchText) => {
  let name;
  if (!value) return [];
  if (!searchText) return value;
  searchText = searchText.toLowerCase();
  return value.filter((it) => {
    name = it['name'];
    return name.toLowerCase().includes(searchText);
  });
};

export const DiscountTypePipe = (value) => {
  if (value) {
    let val = '';
    if (value === 'bulk') {
      val = 'Group';
    } else if (value === 'coupon') {
      val = 'Coupon';
    } else if (value === 'loyalty') {
      val = 'Loyalty';
    } else if (value === 'referral') {
      val = 'Referral';
    }
    return val;
  }
  return;
};

export const NumberWithOutComma = (value) => {
  if (value) {
    let valWithOutComma = value.split(',');
    let finalVal = '';
    for (let index = 0; index < valWithOutComma.length; index++) {
      finalVal += valWithOutComma[index];
    }
    return '' + finalVal;
  }
  return;
};

export const DashboardEventSorting = (array) => {
  if (array && array.length > 0) {
    let newDate = new Date();
    newDate.setHours(23);
    newDate.setMinutes(59);
    newDate.setSeconds(59);
    newDate.setMilliseconds(999);
    if (array) {
      return array.sort(function (a, b) {
        if (a['endDate'] < newDate.getTime() && b['endDate'] < newDate.getTime()) {
          if (a['endDate'] > b['endDate']) {
            return -1;
          } else if (a['endDate'] < b['endDate']) {
            return 1;
          } else {
            return 0;
          }
        } else {
          if (a['endDate'] < newDate.getTime()) {
            return 1;
          } else if (b['endDate'] < newDate.getTime()) {
            return -1;
          } else {
            if (a['endDate'] < b['endDate']) {
              return -1;
            } else if (a['endDate'] > b['endDate']) {
              return 1;
            } else {
              return 0;
            }
          }
        }
      });
    }
  }
  return;
};

export const AddressTitle = (value) => {
  if (value) {
    if (value === 0) {
      return 'Permanent address';
    }
    if (value === 5) {
      return 'HDOR 2019 address';
    }
    if (value === 6) {
      return 'Freedom run address';
    }
    if (value === 11) {
      return 'TOUR DE 100 address';
    }
    if (value === 7) {
      return 'HDOR 2019 - Finisher Cap address';
    }
    if (value === 12) {
      return 'Resolution run';
    }
    return null;
  }
  return;
};

export const AddressSorting = (array) => {
  if (array && array.length > 0) {
    return array.sort(function (a, b) {
      if (a['eventId'] > b['eventId']) {
        return 1;
      } else if (a['eventId'] < b['eventId']) {
        return -1;
      } else {
        return 0;
      }
    });
  }
};

// eventSorting
export const EventSorting = (array) => {
  if (array && array.length > 0) {
    if (array) {
      return array.sort(function (a, b) {
        if (a['eventDistance'] < b['eventDistance']) {
          return -1;
        } else if (a['eventDistance'] > b['eventDistance']) {
          return 1;
        } else {
          return 0;
        }
      });
    }
  }
  return;
};

// eventSorting with id
export const EventSortingWithId = (array) => {
  if (array && array.length > 0) {
    return array.sort(function (a, b) {
      if (a['id'] < b['id']) {
        return 1;
      } else if (a['id'] > b['id']) {
        return -1;
      } else {
        return 0;
      }
    });
  }
  return;
};

export const FormattedTimePipe = (value) => {
  if (value) {
    let str = value.split(':');
    let finalstr = '';
    if (parseInt(str[0]) > 0) {
      finalstr = parseInt(str[0]) + 'h ';
    }
    if (parseInt(str[0]) >= 1) {
      finalstr += parseInt(str[1]) + 'm ';
    } else {
      finalstr += parseInt(str[1]) + 'm ' + parseInt(str[2]) + 's';
    }
    return finalstr;
  } else {
    return;
  }
};

export const FirstNamePipe = (value) => {
  if (value) {
    let firstName = value.split(' ')[0];
    if (firstName.length > 9) {
      return firstName.substring(0, 6) + '...';
    } else {
      return firstName;
    }
  }
  return;
};

export const NullValuePipe = (value) => {
  if (value) {
    if (value) {
      return value;
    } else {
      return '-';
    }
  }
  return '-';
};

export const ApendPercentagePipe = (value) => {
  if (value) {
    return value + '%';
  }
  return;
};

export const NonNegativePipe = (value) => {
  if (value) {
    if (parseInt(value) > 0) {
      return value;
    } else {
      return '0';
    }
  }
  return '0';
};

export const ShowHunDaysRefCode = (value) => {
  if (value) {
    if (parseInt(value['eventId']) === 46) {
      return value;
    }
  }
  return;
};

export const NumberNullValuePipe = (value) => {
  if (value) {
    return value;
  } else {
    return '0';
  }
};

export const MillionPipe = (number, args) => {
  if (number && args) {
    if (number <= 999) {
      return number;
    }
    // thousands
    else if (number >= 1000 && number <= 999999) {
      return (number / 1000).toFixed(args) + ' K';
      //return number ;
    }
    // millions
    else if (number >= 1000000 && number <= 999999999) {
      return (number / 1000000).toFixed(args) + ' M';
    }
    // billions
    else if (number >= 1000000000 && number <= 999999999999) {
      return (number / 1000000000).toFixed(args) + ' B';
    } else return number;
  }
  return;
};

export const ZeroNumbeValuePipe = (value) => {
  if (value) {
    if (value === 0) {
      return '-';
    } else if (value) {
      return value;
    } else {
      return '-';
    }
  }
  return '-';
};

export const KmToMilePipe = (value) => {
  if (value) {
    return value / 1.6;
  }
  return;
};

export const MinPerMilePacePipe = (distance, timeInSec) => {
  if (distance && timeInSec) {
    if (distance > 0 && timeInSec > 0) {
      let time = '';
      let pace = Math.round(timeInSec / distance);
      let min = pace / 60;
      let sec = pace % 60;
      time = (min > 9 ? '' + min : '0' + min) + ':' + (sec > 9 ? '' + sec : '0' + sec);
      return time;
    }
    return '00:00';
  }
  return;
};

export const GenderReportPipe = (value) => {
  if (value) {
    if (value === 'all') {
      return 'Overall';
    } else {
      return value;
    }
  }
  return;
};

export const GenderViewReportPipe = (value) => {
  if (value) {
    if (value === 'all') {
      return 'All Genders';
    } else {
      return value;
    }
  }
  return;
};

export const AgeCatPipe = (value) => {
  if (value) {
    if (value === 'all') {
      return 'Overall';
    } else {
      return value + ' years';
    }
  }
  return;
};

export const AgeCategoryPipe = (value) => {
  if (value) {
    if (value === 'all') {
      return 'All Ages';
    } else {
      return value + ' years';
    }
  }
  return;
};

export const OtherToNone = (value) => {
  if (value) {
    if (value === 'Other') {
      return 'None';
    } else {
      return value;
    }
  }
  return;
};

export const YesOrNoPipe = (value) => {
  if (value) {
    return 'Yes';
  } else {
    return 'No';
  }
};

export const TruncatePipe = (value, args) => {
  if (value && args?.length > 0) {
    if (value) {
      const limit = args.length > 0 ? parseInt(args[0], 10) : 20;
      const trail = args.length > 1 ? args[1] : '...';
      return value.length > limit ? value.substring(0, limit) + trail : value;
    }
  }
  return;
};

export const DateArreayFromStringPipe = (value) => {
  if (value) {
    return value.split(',');
  } else {
    return;
  }
};

export const CreatedDateSorting = (array) => {
  if (array && array.length > 0) {
    if (array) {
      return array.sort(function (a, b) {
        if (a['createdTs'] > b['createdTs']) {
          return -1;
        } else if (a['createdTs'] < b['createdTs']) {
          return 1;
        } else {
          return 0;
        }
      });
    }
  } else {
    return;
  }
};

export const TimeWithouthours = (value) => {
  if (value) {
    let str = value.split(':');
    let timeStr = str[1] + ':' + str[2];
    return timeStr;
  } else {
    return;
  }
};

export const SpeedForLap = (distance, time) => {
  if (distance && time) {
    let km = distance / 1000;
    let hour = time / 3600;
    return km / hour;
  } else {
    return;
  }
};

export const PaceForLap = (pace) => {
  if (pace) {
    let min = Math.trunc(pace / 60);
    let sec = Math.trunc(pace % 60);
    return (min > 9 ? '' + min : '0' + min) + ':' + (sec > 9 ? '' + sec : '0' + sec);
  } else {
    return;
  }
};

export const RandomSorting = (arrayObj) => {
  if (arrayObj && arrayObj?.length > 0) {
    if (arrayObj) {
      let sortedArray = arrayObj.sort((a, b) => {
        let randomNum = Math.random();
        let greaterThanZeroRandomNum = Math.trunc(randomNum * 10);
        greaterThanZeroRandomNum = greaterThanZeroRandomNum % 2;
        if (greaterThanZeroRandomNum === 0) {
          return -1;
        } else {
          return 0;
        }
      });
      return sortedArray;
    }
    return arrayObj;
  } else {
    return;
  }
};

export const CustomDateStylePipe = (value) => {
  if (value) {
    let monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    // var d = new Date();
    let dateArr = value.split('-');
    let day = dateArr[2];
    let month = parseInt(dateArr[1]) - 1;
    // let year = dateArr[2];
    let dateStr = monthNames[month] + ' ' + day;
    return dateStr;
  } else {
    return;
  }
};

export const FindUrl = (isCompleted, badgesArray, stage, challenge) => {
  if (isCompleted && badgesArray && stage && challenge) {
    let badgeURL;
    badgesArray.forEach((badgesItem) => {
      if (badgesItem.stageId === stage) {
        badgesItem.stageInfo.forEach((challengeItem) => {
          if (challengeItem.challengeId === challenge) {
            if (isCompleted) {
              badgeURL = challengeItem.challengeInfo.badgesURL.color.toString();
            } else {
              badgeURL = challengeItem.challengeInfo.badgesURL.bw.toString();
            }
          }
        });
      }
    });

    return badgeURL;
  } else {
    return;
  }
};

export const ActivityTypeTitle = (value) => {
  if (value) {
    if (value === 'run') {
      return 'Run';
    } else if (value === 'ride') {
      return 'Ride';
    } else if (value === 'steps') {
      return 'Steps';
    } else if (value === 'unknown') {
      return '-';
    } else {
      return value;
    }
  } else {
    return;
  }
};

export const ShortNamePipe = (fullName) => {
  if (fullName) {
    return fullName
      .split(' ')
      .map((n) => n[0])
      .join('');
  } else {
    return;
  }
};
export const ClipNamePipe = (name) => {
  if (name) {
    let splitArray = name.split(' ');
    let shortName = splitArray.map((n) => n[0]);
    if (shortName[1] && shortName[0]) {
      return shortName[0] + shortName[1];
    } else if (shortName[1] === null) {
      return shortName[0];
    }
  } else {
    return;
  }
};
export const MilesConverter = (distance, eventId) => {
  if (distance && eventId) {
    const milesValue = 62.1371;
    let finalValue = null;
    if (
      eventId === 496 ||
      eventId === 498 ||
      eventId === 504 ||
      eventId === 142 ||
      eventId === 144 ||
      eventId === 129 ||
      eventId === 131 ||
      eventId === 506
    ) {
      finalValue = distance * milesValue;
      finalValue = Math.round(finalValue);
      finalValue = finalValue / 100;
    } else {
      finalValue = distance;
    }
    return finalValue;
  } else {
    return;
  }
};
export const DayFinderPipe = (date, eventDates) => {
  if (date && eventDates) {
    let hdorStartDate = new Date(eventDates.startDate);
    let hdorEndtDate = new Date(eventDates.endDate);
    let activityDate = new Date(date);
    activityDate.setHours(23);
    activityDate.setMinutes(59);
    activityDate.setSeconds(59);
    activityDate.setMilliseconds(999);
    let dateDiff;
    if (activityDate.getTime() < hdorEndtDate.getTime()) {
      dateDiff = activityDate.getTime() - hdorStartDate.getTime();
    } else {
      dateDiff = hdorEndtDate.getTime() - hdorStartDate.getTime();
    }
    return Math.floor(dateDiff / (1000 * 3600 * 24)) + 1;
  } else {
    return;
  }
};
export const SortingByStartDate = (array) => {
  if (array) {
    return array.sort(function (a, b) {
      if (a['activityDate'] < b['activityDate']) {
        return 1;
      } else if (a['activityDate'] > b['activityDate']) {
        return -1;
      } else {
        return 0;
      }
    });
  } else {
    return;
  }
};

export const ConvertMtoKM = (value) => {
  if (value) {
    let dist = value / 1000;
    let removeFrac = Math.round(dist);
    let newnum = removeFrac;
    return newnum;
  } else {
    return;
  }
};

export const GetTitleFromStartTime = (value) => {
  if (value) {
    let strStartDate = value.split(' ');
    let strStartTime = strStartDate[1].split(':');
    let hoursGet = Number(strStartTime[0]);
    if (hoursGet >= 0 && hoursGet < 12) {
      return 'Morning Activity';
    } else if (hoursGet >= 12 && hoursGet < 16) {
      return 'Afternoon Activity';
    } else if (hoursGet >= 16 && hoursGet < 23) {
      return 'Evening Activity';
    } else {
      return value;
    }
  } else {
    return null;
  }
};

export const FormatTimerPipe = (value) => {
  if (value) {
    let minute = Math.trunc(value / 60);
    let second = value % 60;
    return (minute > 9 ? minute : '0' + minute) + ':' + (second > 9 ? second : '0' + second);
  } else {
    return null;
  }
};

export const genderCheckIfOther = (value) => {
  if (value) {
    if (value === 'M') return 'Male';
    else if (value === 'F') return 'Female';
    else if (value === 'O') return 'Male';
    else return 'Male';
  } else {
    return null;
  }
};

export const ConvertToCSV = (objArray, headerList) => {
  let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  let str = '';
  let row = 'S.No,';

  for (let index in headerList) {
    let value = headerList[index];
    if (headerList[index] === 'code') {
      value = 'Discount code';
    } else if (headerList[index] === 'ticket') {
      value = 'Ticket name';
    } else if (headerList[index] === 'used') {
      value = 'Used';
    } else if (headerList[index] === 'usedBy') {
      value = 'Used By';
    }
    row += value + ',';
  }
  row = row.slice(0, -1);
  str += row + '\r\n';
  for (let i = 0; i < array.length; i++) {
    let line = i + 1 + '';
    for (let index in headerList) {
      let head = headerList[index];
      line += ',' + convertValueToUserText(array[i][head]);
    }
    str += line + '\r\n';
  }
  return str;
};

export const convertValueToUserText = (val) => {
  if (val === true) {
    return 'Yes';
  } else if (val === false) {
    return 'No';
  } else if (val) {
    return val;
  } else {
    return '-';
  }
};
export const timeStampToDate = (value) => {
  if (value) {
    var monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    var d = new Date(value);
    let dateStr = monthNames[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
    return dateStr;
  }
  return null;
};
export const formatTime = (value) => {
  if (value) {
    var d = new Date(value);
    let dateStr = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
    return dateStr;
  }
  return;
};

export const sortArrayToReturn = (chartData) => {
  if (chartData) {
    let sortData = chartData.sort((a, b) => {
      if (a.runDate < b.runDate) {
        return -1;
      } else {
        return 0;
      }
    });
    return sortData.reverse();
  }
  return [];
};

export const daysInMonth = (month, year) => {
  return new Date(year, month, 0).getDate();
};

export const prepareDaysByDate = (startDate, endDate, daysCount) => {
  let WeekArray = [];
  let oneDayMilis = 24 * 60 * 60 * 1000;
  for (let index = 0; index < daysCount; index++) {
    let dateToPush = new Date(startDate + index * oneDayMilis);
    WeekArray.push(dateToPush);
  }
  return WeekArray;
};

export const getDateWeek = (d) => {
  let date = new Date(d + 330 * 60000);
  return moment(date).format('ddd');
};
export const getDatemonth = (d) => {
  let date = new Date(d + 330 * 60000);
  let day = date.getUTCDate();
  let dateStr = day;
  return dateStr;
};

export const formatAMPM = (date) => {
  let titleArray = ['Morning activity', 'Afternoon activity', 'Evening activity', 'Night activity'];
  let res;
  var hours = date.getHours();
  var ampm = hours >= 12 ? 'pm' : 'am';
  if (ampm.toUpperCase() === 'AM') {
    res = titleArray[0].trim();
  } else if (ampm.toUpperCase() === 'PM') {
    if (hours === 12 || hours <= 15) {
      res = titleArray[1].trim();
    } else if (hours > 15 && hours <= 19) {
      res = titleArray[2].trim();
    } else if (hours > 19 && hours <= 24) {
      res = titleArray[3].trim();
    }
  }
  return res;
};
export const getSecFromTime = (hours, min, sec) => {
  if (hours && min && sec) {
    let hrSec = 0;
    let minSec = 0;
    let finalSec = 0;
    if (hours) {
      hrSec = hours * 3600;
    }
    if (min) {
      minSec = min * 60;
    }
    finalSec = hrSec + minSec + sec;
    return finalSec;
  }
  return;
};

export const convertNumber = (val) => {
  let numberArr = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09'];
  if (val) {
    if (parseInt(val) < 10) {
      return numberArr[parseInt(val)];
    }
    return val;
  } else {
    return '00';
  }
};

//convert 2022-12-20 01:00:00 -->  01:00 PM/AM
export const setTime = (date) => {
  let strStartDate = date;
  let startTime = strStartDate.split(' ');
  let startTimeSplit = startTime[1].split(':');
  let hours;
  let meridian;
  if (parseInt(startTimeSplit[0]) === 12) {
    hours = parseInt(startTimeSplit[0]);
    meridian = ' PM';
  } else if (parseInt(startTimeSplit[0]) === 0) {
    hours = 12;
    meridian = ' AM';
  } else if (parseInt(startTimeSplit[0]) > 12) {
    hours = parseInt(startTimeSplit[0]) - 12;
    meridian = ' PM';
  } else {
    hours = parseInt(startTimeSplit[0]);
    meridian = ' AM';
  }
  return hours + ':' + startTimeSplit[1] + meridian;
};

export const sortArrayByName = (array) => {
  if (array.length > 0) {
    array.sort(function (a, b) {
      var nameA = a.name.toLowerCase(),
        nameB = b.name.toLowerCase();
      if (nameA < nameB)
        //sort string ascending
        return -1;
      if (nameA > nameB) return 1;
      return 0; //default return value (no sorting)
    });
    return array;
  }
  return 0;
};

export const roundoffNumber = (value, digit) => {
  if (value) {
    return (Math.round(value * 100) / 100).toFixed(digit);
  }
  return '0';
};

export const getUserStatsiIcon = (type) => {
  if (type) {
    if (type === 'points') {
      return pointIcon;
    } else if (type === 'steps' || type === 'maxSteps') {
      return stepsIcon;
    } else {
      return challenge;
    }
  }
};

export const AvailableConnectedApps = {
  GOOGLE_FIT: 'googlefit',
  STAVA: 'strava',
  POLAR: 'polar',
  WAHOO: 'wahoo',
  MAPMYRUN: 'mapmyrun',
  MAPMYRIDE: 'mapmyride',
  FITBIT: 'fitbit',
  APPLEHAELTH: 'applehealth',
  APPLE: 'apple',
  GARMIN: 'garmin',
  HDOR: 'hdor',
  UNDER_ARMOUR: 'underarmour',
  HEALTH_CONNECT: 'healthconnect',
  MAP_MY_WALK: 'mapmywalk',
  MAP_MY_FITNESS: 'mapmyfitness',
};

export const getConnectedAppIcon = (app) => {
  if (!app) {
    return '';
  }
  if (app?.toLowerCase() === AvailableConnectedApps.MAP_MY_WALK) {
    return mapMyWalkLogo;
  } else if (app?.toLowerCase() === AvailableConnectedApps.MAP_MY_FITNESS) {
    return mapMyFitnessLogo;
  } else if (app?.toLowerCase() === AvailableConnectedApps.UNDER_ARMOUR) {
    return underArmourLogo;
  } else if (app?.toLowerCase() === AvailableConnectedApps.HEALTH_CONNECT) {
    return healthConnectLogo;
  } else if (app?.toLowerCase() === AvailableConnectedApps.APPLEHAELTH) {
    return appleHealth;
  } else if (app?.toLowerCase() === AvailableConnectedApps.APPLE) {
    return appleHealth;
  } else if (app?.toLowerCase() === AvailableConnectedApps.GARMIN) {
    return garmin;
  } else if (app?.toLowerCase() === AvailableConnectedApps.GOOGLE_FIT) {
    return googlefit;
  } else if (app?.toLowerCase() === AvailableConnectedApps.WAHOO) {
    return wahoo;
  } else if (app?.toLowerCase() === AvailableConnectedApps.POLAR) {
    return polar;
  } else if (app?.toLowerCase() === AvailableConnectedApps.FITBIT) {
    return fitbit;
  } else if (app?.toLowerCase() === AvailableConnectedApps.STAVA) {
    return stava;
  } else if (app?.toLowerCase() === AvailableConnectedApps.MAPMYRIDE) {
    return mapmyride;
  } else if (app?.toLowerCase() === AvailableConnectedApps.MAPMYRUN) {
    return mapmyrun;
  } else if (app?.toLowerCase() === AvailableConnectedApps.HDOR) {
    return hdorIcon;
  }
};

export const getConnectedAppSports = (app) => {
  if (!app) {
    return '';
  }
  if (app?.toLowerCase() === AvailableConnectedApps.GARMIN) {
    return SUPPORTED_SPORTS_GARMIN;
  } else if (app?.toLowerCase() === AvailableConnectedApps.GOOGLE_FIT) {
    return SUPPORTED_SPORTS_GOOGLEFIT;
  } else if (app?.toLowerCase() === AvailableConnectedApps.FITBIT) {
    return SUPPORTED_SPORTS_FITBIT;
  } else if (app?.toLowerCase() === AvailableConnectedApps.STAVA) {
    return SUPPORTED_SPORTS_STAVA;
  } else if (app?.toLowerCase() === AvailableConnectedApps.MAPMYRIDE) {
    return SUPPORTED_SPORTS_MAPMYRIDE;
  } else if (app?.toLowerCase() === AvailableConnectedApps.MAPMYRUN) {
    return SUPPORTED_SPORTS_MAPMYRUN;
  } else if (app?.toLowerCase() === AvailableConnectedApps.UNDER_ARMOUR) {
    return SUPPORTED_SPORTS_MAPMYRUN;
  } else if (app?.toLowerCase() === AvailableConnectedApps.POLAR) {
    return SUPPORTED_SPORTS_POLAR;
  } else if (app?.toLowerCase() === AvailableConnectedApps.WAHOO) {
    return SUPPORTED_SPORTS_WAHOO;
  }
};

export const getSocialLinks = (app, platform) => {
  if (!app) {
    return '';
  }
  if (app?.toLowerCase() === AvailableConnectedApps.GARMIN) {
    if (platform?.toUpperCase() === SOCIAL_LINK_PLATFORM?.googleStore) {
      return GARMIN_SOCIAL_LINKS.googleStore;
    } else if (platform === SOCIAL_LINK_PLATFORM?.appleStore) {
      return GARMIN_SOCIAL_LINKS.appleStore;
    }
  } else if (app?.toLowerCase() === AvailableConnectedApps.GOOGLE_FIT) {
    if (platform?.toUpperCase() === SOCIAL_LINK_PLATFORM?.googleStore) {
      return GOOGLE_FIT_SOCIAL_LINKS.googleStore;
    } else if (platform === SOCIAL_LINK_PLATFORM?.appleStore) {
      return GOOGLE_FIT_SOCIAL_LINKS.appleStore;
    }
  } else if (app?.toLowerCase() === AvailableConnectedApps.FITBIT) {
    if (platform?.toUpperCase() === SOCIAL_LINK_PLATFORM?.googleStore) {
      return FITBIT_SOCIAL_LINKS.googleStore;
    } else if (platform === SOCIAL_LINK_PLATFORM?.appleStore) {
      return FITBIT_SOCIAL_LINKS.appleStore;
    }
  } else if (app?.toLowerCase() === AvailableConnectedApps.STAVA) {
    if (platform?.toUpperCase() === SOCIAL_LINK_PLATFORM?.googleStore) {
      return STAVA_SOCIAL_LINKS.googleStore;
    } else if (platform === SOCIAL_LINK_PLATFORM?.appleStore) {
      return STAVA_SOCIAL_LINKS.appleStore;
    }
  } else if (app?.toLowerCase() === AvailableConnectedApps.MAPMYRIDE) {
    if (platform?.toUpperCase() === SOCIAL_LINK_PLATFORM?.googleStore) {
      return MAPMYRIDE_SOCIAL_LINKS.googleStore;
    } else if (platform === SOCIAL_LINK_PLATFORM?.appleStore) {
      return MAPMYRIDE_SOCIAL_LINKS.appleStore;
    }
  } else if (app?.toLowerCase() === AvailableConnectedApps.MAPMYRUN) {
    if (platform?.toUpperCase() === SOCIAL_LINK_PLATFORM?.googleStore) {
      return MAPMYRUN_SOCIAL_LINKS.googleStore;
    } else if (platform === SOCIAL_LINK_PLATFORM?.appleStore) {
      return MAPMYRUN_SOCIAL_LINKS.appleStore;
    }
  } else if (app?.toLowerCase() === AvailableConnectedApps.POLAR) {
    if (platform?.toUpperCase() === SOCIAL_LINK_PLATFORM?.googleStore) {
      return POLAR_SOCIAL_LINKS.googleStore;
    } else if (platform === SOCIAL_LINK_PLATFORM?.appleStore) {
      return POLAR_SOCIAL_LINKS.appleStore;
    }
  } else if (app?.toLowerCase() === AvailableConnectedApps.WAHOO) {
    if (platform?.toUpperCase() === SOCIAL_LINK_PLATFORM?.googleStore) {
      return WAHOO_SOCIAL_LINKS.googleStore;
    } else if (platform === SOCIAL_LINK_PLATFORM?.appleStore) {
      return WAHOO_SOCIAL_LINKS.appleStore;
    }
  }
};

export const getEventIconBySportType = (type) => {
  if (type) {
    if (type?.toLowerCase() === 'running') {
      return <FaRunning className="fs-6" />;
    } else if (type?.toLowerCase() === 'cycling') {
      return <BiCycling className="fs-6" />;
    } else if (['steps'].includes(type?.toLowerCase())) {
      return <IoFootstepsSharp className="fs-6" />;
    } else if (['walk', 'walking'].includes(type?.toLowerCase())) {
      return <FaWalking className="fs-6" />;
    }
  }
};

export const getSportTypeIcon = (type) => {
  if (type) {
    if (type?.toLowerCase() === 'running') {
      return <FaRunning />;
    } else if (type?.toLowerCase() === 'cycling') {
      return <BiCycling />;
    } else if (['steps'].includes(type?.toLowerCase())) {
      return <IoFootstepsSharp className="fs-6" />;
    } else if (['walk', 'walking'].includes(type?.toLowerCase())) {
      return <FaWalking className="fs-6" />;
    }
  }
};

export const getConnectedAppURL = (app) => {
  if (!app) {
    return '';
  }
  if (app?.toLowerCase() === AvailableConnectedApps.GARMIN) {
    return apiPath.initalizeGarmin;
  } else if (app?.toLowerCase() === AvailableConnectedApps.GOOGLE_FIT) {
    return apiPath.initalizeGoogleFit;
  } else if (app?.toLowerCase() === AvailableConnectedApps.FITBIT) {
    return apiPath.initalizeFitbit;
  } else if (app?.toLowerCase() === AvailableConnectedApps.STAVA) {
    return apiPath.initalizeStava;
  } else if (app?.toLowerCase() === AvailableConnectedApps.MAPMYRIDE) {
    return apiPath.initalizeMapMyRide;
  } else if (app?.toLowerCase() === AvailableConnectedApps.MAPMYRUN) {
    return apiPath.initalizeMapMyRun;
  } else if (app?.toLowerCase() === AvailableConnectedApps.POLAR) {
    return apiPath.initalizePolar;
  } else if (app?.toLowerCase() === AvailableConnectedApps.WAHOO) {
    return apiPath.initalizeWahoo;
  }
};

export const getFormattedDate = (date) => {
  if (date) {
    return dayjs(date).format('YYYY-MM-DD');
  }
  return date;
};

export const getFormattedDateUsingFormat = (date, format) => {
  if (date) {
    return dayjs(new Date(date)).format(format);
  }
  return date;
};

export const isOneDayEvent = (startDate, endDate) => {
  const startDay = new Date(startDate).getDate();
  const endDay = new Date(endDate).getDate();
  const startMonth = new Date(startDate).getMonth();
  const endMonth = new Date(endDate).getMonth();
  const startYear = new Date(startDate).getFullYear();
  const endYear = new Date(endDate).getFullYear();
  if (startDay === endDay && startMonth === endMonth && startYear === endYear) {
    return moment(startDate).format('DD MMM, YYYY');
  } else {
    return null;
  }
};

export const formatSeconds = (s) => new Date(s * 1000).toISOString().substr(11, 8);

export const checkDateDifferenceYear = (startDate, endDate) => {
  const startYear = new Date(startDate).getFullYear();
  const endYear = new Date(endDate).getFullYear();
  if (startYear === endYear) {
    return dayjs(startDate).format('DD MMM');
  } else {
    return dayjs(startDate).format('DD MMM, YYYY');
  }
};

export const get2digitAfterDecimal = (value) => {
  if (value && isFloat(value)) {
    return parseFloat(value).toFixed(2);
  } else {
    return value;
  }
};

export const truncateValue = (value) => {
  if (value) {
    return Math.trunc(value);
  } else {
    return value;
  }
};

export const getAmountInDecimal = (value) => {
  return parseFloat(value).toFixed(2);
};

const CurrencySymbols = {
  EUR: '€',
  GBP: '£',
  USD: '$',
  INR: '₹',
};

export const getCurrencyIcon = (currency) => {
  return currency === 'INR'
    ? CurrencySymbols.INR
    : currency === 'USD'
      ? CurrencySymbols.USD
      : currency === 'EUR'
        ? CurrencySymbols.EUR
        : currency === 'GBP'
          ? CurrencySymbols.GBP
          : currency;
};

export const calculateStartOfTheDayTime = (date) => {
  let timeOfDay = new Date(date);
  timeOfDay.setHours(0);
  timeOfDay.setMinutes(0);
  timeOfDay.setSeconds(0);
  timeOfDay.setMilliseconds(0);
  return String(timeOfDay);
};

export const calculateEndOfTheDayTime = (date) => {
  let timeOfDay = new Date(date);
  timeOfDay.setHours(23);
  timeOfDay.setMinutes(59);
  timeOfDay.setSeconds(59);
  timeOfDay.setMilliseconds(999);
  return String(timeOfDay);
};

export const checkDateBetween = (startDate, endDate, compareDate) => {
  if (startDate && endDate && compareDate) {
    let compareDateObj = calculateStartOfTheDayTime(compareDate);
    let date1ms = new Date(startDate).getTime();
    let date2ms = new Date(endDate).getTime();
    let compare = new Date(compareDateObj).getTime();
    if (date1ms <= compare && compare <= date2ms) {
      return true;
    }
  }
  return false;
};

export const checkDateBefore = (startDate, endDate) => {
  if (startDate && endDate) {
    let date1ms = new Date(startDate).getTime();
    let date2ms = new Date(endDate).getTime();
    if (date1ms >= date2ms) {
      return true;
    }
  }
  return false;
};

const widgetBreak = 1;

const viewPortWidth = window.innerWidth;

// widgetCol width ratio of widgets
// totalCols total cols in viewport
export const calculateGridSizeBox = (totalCols, widgetCol) => {
  let viewPort = 100;
  let width = viewPort;
  let viewWidth = viewPortWidth;
  switch (totalCols) {
    case 2: {
      if (widgetCol === 1) {
        width = (viewPort - widgetBreak) / 2;
      }
      break;
    }
    case 3: {
      if (widgetCol === 2) {
        width = viewPort / 2 - 10;
      } else if (widgetCol === 1) {
        width = (viewPort - widgetBreak * 2) / 1;
      }
      break;
    }

    case 6: {
      if (widgetCol === 2) {
        width = ((viewPort - widgetBreak) / 6) * 1;
      } else if (widgetCol === 1) {
        width = (viewPort - widgetBreak * 4) / 1;
        viewWidth -= 200;
      }
      break;
    }

    default:
      break;
  }

  return (viewWidth * width) / 100;
};

export const calculateHeight = (totalCols, width, column, row) => {
  let height = width;

  switch (totalCols) {
    case 2: {
      if (column === 2 && row === 1) {
        height = width / 2;
      } else if (column === 1 && row === 2) {
        height = width * 2;
      }
      break;
    }
    case 3: {
      if (column === 3 && row === 1) {
        height = width / 3;
      } else if (column === 3 && row === 2) {
        height = width / 3;
      } else if (column === 2 && row === 3) {
        height = (width / 2) * 3;
      } else if (column === 2 && row === 1) {
        height = width / 2;
      } else if (column === 1 && row === 2) {
        height = width * 2;
      } else if (column === 1 && row === 3) {
        height = width * 3;
      }
      break;
    }

    case 6: {
      if (column === 6 && row === 1) {
        height = width / 6;
      } else if (column === 6 && row === 2) {
        height = (width / 6) * 2;
      } else if (column === 2 && row === 6) {
        height = (width / 2) * 6;
      } else if (column === 2 && row === 1) {
        height = width / 2;
      } else if (column === 1 && row === 2) {
        height = width * 2;
      } else if (column === 1 && row === 6) {
        height = width * 6;
      } else if (column === 1 && row === 1) {
        height = width / 10;
      }
      break;
    }

    default:
      break;
  }

  return height;
};

export const FormatElapsedTime = (res) => {
  let value = res;
  let hours;
  let mins;
  let seconds;
  if (value > 0) {
    hours = Math.trunc(value / 3600);
    mins = Math.trunc((value - hours * 3600) / 60);
    seconds = Math.trunc(value - hours * 3600 - mins * 60);
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (mins < 10) {
      mins = '0' + mins;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    return '' + hours + ':' + mins + ':' + seconds;
  } else {
    return '00:00:00';
  }
};

export const elapsedTimeToSecondsFormat = (res) => {
  let value = res;
  let hours;
  let mins;
  let seconds;
  if (value > 0) {
    hours = Math.trunc(value / 3600);
    mins = Math.trunc((value - hours * 3600) / 60);
    seconds = Math.trunc(value - hours * 3600 - mins * 60);
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (mins < 10) {
      mins = '0' + mins;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    return '' + hours + ':' + mins + ':' + seconds;
  } else {
    return '00:00:00';
  }
};

export const IsDecimal = (value) => {
  if (value && Number(value)) {
    if (isFloat(value)) {
      return value?.toFixed(2);
    }
  }
  return value;
};

function isFloat(n) {
  return !Number.isInteger(n);
}

export function fixToken(value) {
  return value.replace(',', '').trim();
}

export function calculateWidgetWidth(containerWidth, noOfColumns, padding, ratioColumn) {
  const calculatedWidth = containerWidth - padding * (noOfColumns - 1);
  return (calculatedWidth / noOfColumns) * ratioColumn;
}

export function calculateWidgetHeight(heightOfOneRow, noOfRows) {
  return heightOfOneRow * noOfRows;
}

export const getStatsBasedOnStatsType = (id) => {
  switch (id) {
    case 'individual_activity':
      return INDIVIDUAL_ACTIVITY;

    case 'individual_activity_multisport':
      return INDIVIDUAL_ACTIVITY;

    case 'individual_summary':
      return INDIVIDUAL_SUMMARY;

    case 'team_activity':
      return TEAM_ACTIVITY;

    case 'team_summary':
      return TEAM_SUMMARY;

    case 'team_summary_points':
      return TEAM_SUMMARY_POINTS;

    case 'team_summary_steps_v2':
      return INDIVIDUAL_SUMMARY_V2;

    case 'team_activity_distance':
      return TEAM_ACTIVITY_DISTANCE;

    default:
      break;
  }
};

export const formatNumberWithShorthand = (num) => {
  if (num > 0) {
    if (num >= 1000000000000) {
      return (num / 1000000000000).toFixed(1).replace(/\.0$/, '') + 'T';
    }
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
    }
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
    }
    return num.toString();
  }
  return num;
};

export const getDurationOfEvent = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  const diffInMillis = end.getTime() - start.getTime();

  const diffInDays = diffInMillis / (1000 * 60 * 60 * 24);

  return Math.floor(diffInDays) + 1;
};

export const SecondsToHHMMSS = (value) => {
  if (value) {
    let seconds = value,
      hh = 0,
      mm = 0,
      ss = 0;
    hh = Math.floor(seconds / 3600);
    seconds = seconds % 3600;
    mm = Math.floor(seconds / 60);
    ss = seconds % 60;
    if (hh > 0) {
      return hh + 'h ' + mm + 'm ' + ss + 's';
    }
    if (mm > 0) {
      return mm + 'm ' + ss + 's';
    }
    return ss + 's';
  }
  return null;
};

export function sortByKey(array, key) {
  return array.sort((a, b) => {
    if (a[key] < b[key]) {
      return -1;
    }
    if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  });
}

export function getSecondLastDateBetweenDates(startDate, endDate) {
  if (
    !(startDate instanceof Date) ||
    !(endDate instanceof Date) ||
    isNaN(startDate.getTime()) ||
    isNaN(endDate.getTime())
  ) {
    throw new Error('Invalid date(s) provided');
  }

  if (startDate > endDate) {
    const temp = startDate;
    startDate = endDate;
    endDate = temp;
  }

  const dates = [];
  let currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    dates.push(new Date(currentDate));
    currentDate.setDate(currentDate.getDate() + 1);
  }

  if (dates.length < 2) {
    return null;
  }

  return dates[dates.length - 3];
}
export const getHyphenForNull = (value) => {
  if (value && value != '0') {
    return value;
  } else {
    return '-';
  }
};

// pass excludeZeros = true will excludes hour if it is zero or seconds if hours is greter than zero
export const getTimeByFormat = (
  { hours = 0, minutes = 0, seconds = 0 },
  format = 'hh:mm:ss',
  excludeZeros = false,
) => {
  const raw = { h: hours, m: minutes, s: seconds };
  const padded = {
    hh: hours > 9 ? hours : '0' + hours,
    mm: minutes > 9 ? minutes : '0' + minutes,
    ss: seconds > 9 ? seconds : '0' + seconds,
  };
  const isColun = format.includes(':');
  if (excludeZeros) {
    if (raw?.h <= 0) {
      const newFormat = format.replace(/\b(h{1,2}:?)\b/gi, '').trim();
      return newFormat
        .replace(/mm/g, padded.mm)
        .replace(/m/g, isColun ? raw.m : raw.m + 'm')
        .replace(/ss/g, padded.ss)
        .replace(/s/g, isColun ? raw.s : raw.s + 's');
    }
    if (raw?.h >= 1) {
      const newFormat = format.replace(/\b(s{1,2}:?)\b/gi, '').trim();
      return newFormat
        .replace(/hh/g, padded.hh)
        .replace(/h/g, isColun ? raw.h : raw.h + 'h')
        .replace(/mm/g, padded.mm)
        .replace(/m/g, isColun ? raw.m : raw.m + 'm');
    }
  }
  return format
    .replace(/hh/g, padded.hh)
    .replace(/h/g, isColun ? raw.h : raw.h + 'h')
    .replace(/mm/g, padded.mm)
    .replace(/m/g, isColun ? raw.m : raw.m + 'm')
    .replace(/ss/g, padded.ss)
    .replace(/s/g, isColun ? raw.s : raw.s + 's');
};
export const getHMSBySeconds = (sec) => {
  const hours = Math.trunc(sec / 3600);
  const minutes = Math.trunc((sec - hours * 3600) / 60);
  const seconds = Math.trunc(sec - hours * 3600 - minutes * 60);
  return { hours, minutes, seconds };
};
export const getDateFormat = (date) => {
  return dayjs(date).format('DD MMM, YYYY');
};
export const getDateMonthFormat = (date) => {
  return dayjs(date).format('MMM DD');
};
